// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__nBxx7","filled":"Accordion_filled__mgrgB","hasBorderBottom":"Accordion_hasBorderBottom___wunP","secondary":"Accordion_secondary__rLqKa"};